module.exports = __webpack_public_path__ + "static/media/home-top-text.b6da7a4f.png";